module.exports = __webpack_public_path__ + "img/elem_air.82b527a5.svg";